export enum PaymentMethods {
  PIX = 1,
  BOLETO = 2,
  SOLFACIL_FINANCING = 3,
  OTHERS = 4,
  BNPL = 5,
  OTHERS_FINANCING = 6,
  CREDIT_CARD = 7,
  BLACK_PAYMENT_CONDITIONS = 8,
}

export enum UserProfile {
  ADMIN = 'admin',
  MANAGER = 'gerente',
}

export enum OrderActionId {
  PAY = 'PAY',
  GET_MIRROR = 'GET_MIRROR',
  BILLING_NOTE = 'BILLING_NOTE',
  STOCK_NOTE = 'STOCK_NOTE',
  CANCEL = 'CANCEL',
  TRACK = 'TRACK',
  GO_TO_FINANCING = 'GO_TO_FINANCING',
  GO_TO_INSTALLMENT = 'GO_TO_INSTALLMENT',
  OPEN_PAYMENT_LINK = 'OPEN_PAYMENT_LINK',
  GET_DETAILS = 'GET_DETAILS',
}
